import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const loadingContent: ThemedFunctor = ({ theme }) => css`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${theme.remSize[50]};
`;

export const features: ThemedFunctor = () => css`
  display: flex;
`;

export const feature: ThemedFunctor = ({ theme }) => css`
  padding: 0 ${theme.remSize[100]};
  display: flex;
  flex-direction: column;
  border-left: 1px solid ${theme.color.border.neutral.default.low};
  gap: ${theme.remSize[25]};
`;
